<div class="d-flex align-items-center gap-2">
 <svg-icon src="assets/icons/flag/fr.svg" ></svg-icon>
  <div class="mt-1">{{ data.numTel }}</div>
</div>
